import {connect} from 'react-redux';

import {QuicksurveyStore} from 'client/common/types';

import {getPreset} from 'client/common/store/selectors/question-bank';

import {OwnProps, StateProps} from './types';

import Component from './survey-presets';

const mapStateToProps = (state: QuicksurveyStore): StateProps => {
    return {
        preset: getPreset(state)
    };
};

export default connect<StateProps, null, OwnProps>(mapStateToProps)(Component);
